// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1863s","badges":"styles_badges__13eJ5"};